namespace TR {
    class PropertyTypeFilter {
        model: any;
        aggregate: any;
        limit: any;
        showAll: boolean;
        propArray: any;
        people: any;

        constructor($scope: ng.IScope,
                    occupancyService: Core.OccupancyService) {
            $scope.$watch('pt.aggregate', agg => {
                if (!agg) { return; }
                this.people = occupancyService.getNumberOfNonInfantPassengers();
                let propArray:any = [];
                for (let key in agg) {
                    propArray.push(_.extend(agg[key], { id: key }));
                }
                _.set(
                    _.minBy(propArray, (v:any) => v.MinPrice),
                    'cheapest',
                    true
                );
                this.propArray = propArray;
            });
        }


        isSet() {
            return !!_.size(this.model);
        }

        reset() {
            this.model = [];
        }

        more(all:boolean) {
            this.showAll = all;
        }

        showMoreLess() {
            return Object.keys(this.aggregate || {}).length > this.limit;
        }
    }

    angular
        .module('TR')
        .directive('propertyTypeFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=PropertyTypeFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    limit: '@',
                    priceMode: '='
                },
                controller: PropertyTypeFilter,
                controllerAs: 'pt'
            };
        });

    class PropertyTypeFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="pt.isSet()">
                    <a
                        href="#"
                        ng-repeat="type in pt.model"
                        class="filter-criterion-toggle"
                        ng-click="pt.remove(type)">
                        <span> {{pt.getName(type)}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;

        constructor($scope: ng.IScope, analytics: any) {
            $scope.$watch('pt.model', (value: any) => {
                if (!value || !value.length) { return; }
                let pt = value.map(v => this.getName(v));
                analytics.track(
                    'mixpanel',
                    'HolidayDealsFilterPropertyType',
                    { value: pt }
                );
            });
        }

        getName(type) {
            if (!this.aggregate) { return ''; }
            return (this.aggregate[type] || {}).Title;
        }

        isSet() {
            return !!_.size(this.model);
        }

        remove(type) {
            this.model = this.model.filter(v => v !== type);
        }
    }

    angular
        .module('TR')
        .directive('propertyTypeFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: PropertyTypeFilterLabel.getTemplate(),
                bindToController: {
                    aggregate: '=',
                    model: '='
                },
                controller: PropertyTypeFilterLabel,
                controllerAs: 'pt'
            };
        });

}
